const state = {
    isCrop: false,
    goSel: false
}
const mutations = {
    'showCrop': (state, data) => {
        state.isCrop = data
    },
    'modSel': (state) => {
        var sta = state.goSel;
        sta = !sta;
        state.goSel = sta;
    }
}
const getters = {}
const actions = {}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}